import { UserRoleAdminList } from '../enums/user-role.enum';
import { IAdmin } from '../interfaces/admin.interface';

export function isAdmin(user: { role: string } | null | undefined): user is IAdmin {
  return Boolean(user) && UserRoleAdminList.includes((user as IAdmin).role);
}
